import { render, staticRenderFns } from "./PxCriterioTiposUso.vue?vue&type=template&id=dee64e5a&"
import script from "./PxCriterioTiposUso.vue?vue&type=script&lang=js&"
export * from "./PxCriterioTiposUso.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports